import ProjectProperties from 'core/model2/project/properties/project-properties';
import ProjectModelSession from 'src/core/gd-model/project-session/project-model-session'

const TEMPLATE_CONTENT_DEFAULT = {
    customFields:   false,
    events:         false,
    subProjects:    false,
    subTasks:       false,
    tasks:          false,
}

export const TemplateModelSession = ProjectModelSession.extend({

    props: {

        templateContent: {
            type: 'object',
            default: () => (TEMPLATE_CONTENT_DEFAULT)
        }
    },

    parse(obj) {
        obj.properties = ProjectProperties.normalize(obj.properties);

        // Fix access ?
        if (obj.isTemplate && !obj.access) {
            // Eto ne rabotaet izza initialization... netu eche access... blin
            // if (gd.ac.check.company.isManager()) {
            //     obj.access = 3    // full
            // } else {
            //     obj.access = -10  // read only
            // }
            // nichego tut ne delau poka - smotri project proto app
        }

        if (!obj.templateContent) {
            obj.templateContent = TEMPLATE_CONTENT_DEFAULT
        }

        return obj;
    }
});

// module.exports = TemplateModelSession;